<template>
    <div class="slim user-review-block">
        <h3 class="block-title text-center" v-if="this.content.meta.title"><span class="block-title-content theme-tinted-border">{{this.content.meta.title}}</span></h3>
        <p v-if="currentReview" ref="quote-block" class="quote theme-tinted-before-element" v-html="autoLinkedContent"></p>
        <div class="user-avatar-container text-center">
            <div class="user-avatar-container-item" v-for="userReview in userReviews" @click="setCurrentReview(userReview)">
                <img class="avatar-image" :src="context.storageEndpoint + (userReview.contentUnit.thumbnail_file_name || userReview.contentUnit.file_name)" />
                <div v-if="userReview.id === currentReview.id">{{userReview.name}}</div>
            </div>
        </div>
    </div>
</template>

<script>
    import { EventClickUserReview } from '../../bu/models/GA4';
    import autoLink from '../../mixins/autolink';
    export default {
        props: ['block', 'providerId', 'context'],
        mixins: [autoLink],

        data: function() {
            const content = JSON.parse(this.block.content);

            return {
                id: this.block.id,
                content: content,
                informationBlock: this.block.information_block,
                userReviews: content.userReviews,
                currentReview: content.userReviews.length > 0 ? content.userReviews[0] : null
            };
        },
        computed: {
            autoLinkedContent() {
                return this.autoLink(this.currentReview.content);
            }
        },

        methods: {
            addNewReview() {
                this.userReviews.push(this.createUserReviewPlaceholder());
                this.context.bus.$emit('requestSavingBlock', this.block.id);
            },

            onUserReviewChange(updatedUserReview) {
                for (var i in this.userReviews) {
                    var entry = this.userReviews[i];
                    if (entry.id === updatedUserReview.id) {
                        entry.name = updatedUserReview.name;
                        entry.content = updatedUserReview.content;

                        this.context.bus.$emit('requestSavingBlock', this.block.id);
                        break;
                    }
                }
            },

            onUserReviewDelete(userReview) {
                var newUserReviews = [];
                for (var i in this.userReviews) {
                    var entry = this.userReviews[i];
                    if (entry.id === userReview.id) {
                        continue;
                    }
                    newUserReviews.push(entry);
                }
                this.userReviews = newUserReviews;
                this.context.bus.$emit('requestSavingBlock', this.block.id);
            },

            getContentObject() {
                var userReviews = [];
                for (var i in this.userReviews) {
                    var item = Vue.util.extend({}, this.userReviews[i]);
                    delete item['_frontend'];
                    userReviews.push(item);
                }
                return {
                    userReviews: userReviews
                };
            },

            createUserReviewPlaceholder() {
                return {
                    'id': Vue.dingGenerateLocalId(),
                    'name': '顧客',
                    'content': '真的好棒棒的！',
                    'avatarFileName': '580e848194605713a59bebef0533c704.',
                    'contentUnit': this.createEmptyLocalContentUnit()
                };
            },

            setCurrentReview(review) {
                this.currentReview = review;
                this.trackClickUserReview();
            },

            trackClickUserReview() {
                window.tracker.track(() => new EventClickUserReview());
            }
        }
    }
</script>

<style scoped>
    .avatar-image {
        width: 78px;
        height: 78px;
        border-radius: 39px;
        overflow: hidden;
        margin: 0.8em;
    }

    .user-avatar-container {
        padding: 1.2em 0 1.8em;
    }

    .user-avatar-container-item {
        display: inline-block;
        vertical-align: top;
        cursor: pointer;
    }
    .user-avatar-container-item:hover {
        opacity: 0.8;
    }

    .user-review-block {
        font-size: 12px;
    }

    @media (min-width: 1024px) {
        .user-review-block {
            font-size: 16px;
        }
    }

    .quote {
        text-align: left;
        padding: 1em 0 1em;
        font-size: 1.5em;
        margin: 0 auto;
        width: 80%;
        min-height: 100px;
    }

    .quote::before {
        line-height: 20px;
        display: inline-block;
        content: '〞';
        content: '‶';
        color: #F5A623;
        width: 30px;
        font-size: 72px;
    }
</style>
